import { useStepperContext } from "../../../context/stepper-provider";
import { useNavigate } from "react-router-dom";
import Define from "@/components/define/define";
import PalletConfig from "@/components/pallet-config/pallet-config";
import LpnNo from "@/components/LPN-No";
import PreShip from "@/components/pre-ship/pre-ship";
import PostShip from "@/components/post-ship/post-ship";
import PostStack from "@/components/post-stack/post-stack";
import Summary from "@/components/summary/summary";
import Synopsis from "@/components/synopsis";
import Navbar from "@/components/top-nav";
import StepperNavigation from "../../../components/StepperNavigation";
import ShipTestTruckLayout from "@/components/post-ship/ship-test-truck-layout";
import StackTestLayout from "@/components/post-stack/stack-test-layout";
import Images from "@/components/imagesTab/images";
import Stepper from "@/components/stepper";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { setActivePallet } from "@/redux/slices/pallet/palletSlice";
export default function NewProject() {
    const { stepper } = useStepperContext();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleSuccess = (projectId: string) => {
        navigate(`/projects/edit-project/${projectId}`);
    };
    useEffect(()=>{
        return ()=>{
            dispatch(setActivePallet(null))
        }
    },[])
    return (
        <>
        <Navbar />
        <div className="">

            <Stepper />

            {stepper.when("1", () => (
                <Define  />
            ))}
            {stepper.when("2", () => (
               <div className=" ">
                 <PalletConfig />
               </div>
            ))}
            {stepper.when("3", () => (
                <LpnNo />
            ))}
            {stepper.when("4", () => (
                <PreShip />
            ))}
            {stepper.when("5", () => (
                <ShipTestTruckLayout />
            ))}
            {stepper.when("6", () => (
                <PostShip />
            ))}
            {stepper.when("7", () => (
                <StackTestLayout />
            ))}
            {stepper.when("8", () => (
                <PostStack />
            ))}
            {stepper.when("9", () => (
                <Summary />
            ))}
            {stepper.when("10", () => (
                <Synopsis />
            ))}
            {stepper.when("11", () => (
                <Images />
            ))}
        </div>
        </>
    );
} 